var map = {
	"./collapsible_closed.png": 155,
	"./collapsible_open.png": 156,
	"./default_album_art.png": 45,
	"./sample_album_art.png": 157,
	"./settings.png": 158,
	"./sidebar_albums.png": 159,
	"./sidebar_artists.png": 160,
	"./sidebar_explore.png": 161,
	"./sidebar_genres.png": 162,
	"./sidebar_library.png": 163,
	"./sidebar_parties.png": 164,
	"./sidebar_radio.png": 165,
	"./sidebar_search.png": 166,
	"./user_placeholder.png": 167
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 154;